import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { PageShell } from "../components/PageShell";

export default function ThankYouPage() {
  return (
    <PageShell>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45 }}
        className="flex flex-1 flex-col items-center justify-center text-center"
        data-testid="thankyou-page"
      >
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-coral/15 text-coral">
          <CheckCircle2 size={34} strokeWidth={2} />
        </div>
        <h2 className="mt-6 font-serif text-3xl font-bold leading-tight text-ink">
          Iscrizione confermata
        </h2>
        <p className="mt-5 max-w-sm text-base leading-relaxed text-ink/75">
          Il programma parte domani. Ogni mattina alle 8:00 ti arriva il giorno da fare e ogni sera
          alle 18:00 il check-in. Se non vedi le nostre email, controlla in Promozioni o Spam.
        </p>
      </motion.div>
    </PageShell>
  );
}
